export default function debounce(cb, timeout) {
    let timer = null;
    
    function debounced() {
        const self = this;

        clearTimeout(timer);

        timer = setTimeout(() => {
            cb.apply(self, arguments);
        }, timeout);
    }

    debounced.cancel = function () {
        clearTimeout(timer);
        timer = null;
    };

    return debounced;
}
